import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Typography,
  Box
} from '@mui/material';
import { SubjectAssignStudent } from './subjectAssignApi';

interface SubjectAssignTableProps {
  students: SubjectAssignStudent[];
  selectedStudents: string[];
  onToggleSelect: (studentId: string) => void;
  onToggleSelectAll: (event: React.ChangeEvent<HTMLInputElement>) => void;
  className: string;
  sectionName: string;
}

const SubjectAssignTable: React.FC<SubjectAssignTableProps> = ({
  students,
  selectedStudents,
  onToggleSelect,
  onToggleSelectAll,
  className,
  sectionName
}) => {
  if (students.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography color="textSecondary">No students found for the selected filters.</Typography>
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ mt: 2, maxHeight: '60vh' }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox">
              <Checkbox
                indeterminate={selectedStudents.length > 0 && selectedStudents.length < students.length}
                checked={students.length > 0 && selectedStudents.length === students.length}
                onChange={onToggleSelectAll}
              />
            </TableCell>
            <TableCell>Admission No</TableCell>
            <TableCell>Scholar No</TableCell>
            <TableCell>Student Name</TableCell>
            <TableCell>Class</TableCell>
            <TableCell>Section</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {students.map((student) => {
            const isSelected = selectedStudents.indexOf(student.id) !== -1;

            return (
              <TableRow key={student.id} selected={isSelected} hover>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={isSelected}
                    onChange={() => onToggleSelect(student.id)}
                  />
                </TableCell>
                <TableCell>{student.admissionNumber}</TableCell>
                <TableCell>{student.scholarNumber || '-'}</TableCell>
                <TableCell>{`${student.firstName} ${student.lastName}`}</TableCell>
                <TableCell>{className}</TableCell>
                <TableCell>{sectionName}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SubjectAssignTable;
